import AsoHeader from "../../../components/Aso/Header";
import AsoEnderecoEmpresa from "../../../components/Aso/Register/AsoEnderecoEmpresa";

const AsoRegistroEnderecoEmpresa = () => {
    return(
        <>
            <AsoHeader />
            <AsoEnderecoEmpresa />
        </>
    );
}

export default AsoRegistroEnderecoEmpresa;